import apolloClient from 'ecommerce/utils/apolloClient';
import TimeRanges from 'ecommerce/assets/graphql/queries/catalog/TimeRanges.graphql';

import { timeRangesAdapter } from 'ecommerce/adapters/timeRanges.adapter';

/**
 * Use time_range query to return all time slots defined in backoffice
 * @return {Promise<TimeRanges>}
 */
let getTimeRanges = async () => {
  try {
    const { data } = await apolloClient.query({
      query: TimeRanges,
    });
    return timeRangesAdapter(data.time_ranges);
  } catch (e) {
    throw new Error('getTimeRanges', e);
  }
};

export { getTimeRanges };
